import frUtils from '../../util/frUtils';

(function ($) {
    $.fn.teamGrid = function () {
        return this.each((index, block) => {
            const $self = $(block);

            //team bio popup
            $($self).find('.team-content').on('click', '.team-list', function () {
                if($(this).hasClass('has-modal')) {
                    var userId = $(this).attr('id');
                    var dataUrl = $(this).attr('data-url');
                    frUtils.setUrlHash(dataUrl);
                    teamBioData(userId, $self);
                }
            });

        });
    }

    function teamBioData(userId, $block) {
        //$('.wrap').css('position', 'relative');
        $($block).find('.ajax-loading').addClass('wrap-loading');
        $($block).find('.ajax-loading').show();
        let $modalId = $block.attr('data-modal');
        let $modal = $($block).find('#' + $modalId);
        $.frAjax({
            action: 'userBio',
            data: {
                userId: userId,
            },
        })
            .then(data => {
                $($modal[0]).find('.modal-body').html(data);
                $.frModalOpen($modal[0]);
                $($block).find('.ajax-loading').removeClass('wrap-loading');
                $($block).find('.ajax-loading').hide();
                //$('.wrap').css('position', 'unset');

            })
            .catch(err => {
                console.error(err);
            });
        return this;
    }

    // Function for open modal popup when page load
    function modalOpenOnUrl() {
        // Don't do anything if hash not present
        if(!frUtils.urlHashValue){
            return;
        }

        $('.team-content .team-list').each(function () {
            var dataUrl = $(this).attr('data-url');
            if (dataUrl == frUtils.urlHashValue) {
                $(this).trigger('click');
                return false;
            }
        });
    }

    $(() => {
        $('.team-grid').teamGrid();

        modalOpenOnUrl();
    })

})($);



// WEBPACK FOOTER //
// ./scripts/modules/blocks/team-grid.js